import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function Index() {
  const { isLogged, userDetails } = useSelector((state) => state.auth)

  if (isLogged) {
    if (userDetails?.role == 'employee') {
      return <Navigate to='/app/resources' replace />;
    }
    if (userDetails?.role == 'admin') {
      return <Navigate to='/app/resources' replace />;
    }
  }

  return (
    <div className='auth-layout'>
      <div className="auth-card">
        <Outlet />
      </div>
    </div>
  )
}
